import { useRef } from 'react';
import { dailyContestArticles } from '@/mocks/zh/article';

export default function DailyHighlights() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section id="daily-contest" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              每日大赛
              <span className="text-accent-600"> 一区二区</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">今日最热门赛事与对决，精彩不容错过</p>
          </div>
          <Link
            to="/category/daily-contest"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="relative group">
          <button
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-background-50 border border-background-200 flex items-center justify-center text-foreground-600 hover:text-foreground-950 hover:border-foreground-300 transition-all opacity-0 group-hover:opacity-100 -translate-x-3 md:-translate-x-5 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-x-auto scrollbar-hide pb-2"
            style={{ scrollSnapType: 'x mandatory' }}
          >
            {dailyContestArticles.map((article, index) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="flex-shrink-0 w-[260px] md:w-[280px] bg-background-50 rounded-xl overflow-hidden hover:scale-[1.02] transition-transform duration-300"
                style={{ scrollSnapAlign: 'start' }}
              >
                <div className="relative w-full aspect-square overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-accent-500 text-foreground-950 text-xs font-semibold rounded-full">
                      {article.categoryName}
                    </span>
                  </div>
                  {index === 0 && (
                    <div className="absolute top-3 right-3">
                      <span className="px-2 py-0.5 bg-secondary-500 text-background-50 text-[10px] font-bold rounded">HOT</span>
                    </div>
                  )}
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 mb-3">
                    {article.title}
                  </h3>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400">
                      <i className="ri-eye-line mr-1"></i>
                      {article.views >= 10000
                        ? `${(article.views / 10000).toFixed(0)}万`
                        : article.views}
                    </span>
                    <span className="text-xs text-accent-600 font-medium whitespace-nowrap">
                      立即吃瓜 <i className="ri-arrow-right-s-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <button
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-background-50 border border-background-200 flex items-center justify-center text-foreground-600 hover:text-foreground-950 hover:border-foreground-300 transition-all opacity-0 group-hover:opacity-100 translate-x-3 md:translate-x-5 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/daily-contest"
            className="inline-flex items-center gap-1 text-sm font-medium text-accent-600"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}